// extracted by mini-css-extract-plugin
export var bigger = "q_bz";
export var icon = "q_bq";
export var icons = "q_bw";
export var link = "q_bx";
export var noMobile = "q_by";
export var scrolled = "q_z";